"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendTags = exports.injectState = exports.checkout = exports.SEND_TAGS = exports.INJECT_STATE = exports.CHECKOUT_SUCCESS = exports.CHECKOUT_ERROR = exports.CHECKOUT = void 0;
const INJECT_STATE = 'INJECT_STATE';
exports.INJECT_STATE = INJECT_STATE;
const SEND_TAGS = 'SEND_TAGS';
exports.SEND_TAGS = SEND_TAGS;
const CHECKOUT = 'CHECKOUT';
exports.CHECKOUT = CHECKOUT;
const CHECKOUT_ERROR = 'CHECKOUT_ERROR';
exports.CHECKOUT_ERROR = CHECKOUT_ERROR;
const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';
exports.CHECKOUT_SUCCESS = CHECKOUT_SUCCESS;
const injectState = state => ({
  type: INJECT_STATE,
  payload: state
});
exports.injectState = injectState;
const sendTags = payload => ({
  type: SEND_TAGS,
  payload
});
exports.sendTags = sendTags;
const checkout = _ref => {
  let {
    handsetProductId,
    planProductId,
    upsoldProductIds,
    broadbandProductId,
    businessSolutionId,
    businessSolutionUrl
  } = _ref;
  return {
    type: CHECKOUT,
    payload: {
      handsetProductId,
      planProductId,
      upsoldProductIds,
      broadbandProductId,
      businessSolutionId,
      businessSolutionUrl
    }
  };
};
exports.checkout = checkout;